const About = () => {
    const mySkills = [
        'Nest.js',
        'Node.js',
        'React',
        'JavaScript',
        'TypeScript',
        'Azure',
        'Serverless',
        'MongoDB',
        'Docker',
        'REST Api',
        'Git',
        'Jira',
        'Jest',
        'MUI',
        'React Native',
        'Postman',
    ]
    return (
        <div className="pb-10" id="About">
            <h2 className="mb-5">About</h2>
            <p className="leading-relaxed mb-10 md:text-xs">
                Backend Developer with commercial experience. Strong expertise
                in backend technologies, including Node.js, NestJS, and
                microservices. Skilled in frontend development with React.
                Experienced in Azure serverless functions and server-side
                backend development. Successfully deployed a personal project on
                a Linux server with full configuration and published a mobile
                app on the App Store. I have dedicated myself to creating my own
                project,{' '}
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://code-directory.com/"
                >
                    <span className="underline decoration-1 ">
                        code-directory.com
                    </span>
                </a>
                , which is also available on both the{' '}
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://apps.apple.com/us/app/code-directory/id6505036762"
                >
                    <span className="underline decoration-1 ">App Store</span>
                </a>{' '}
                and the{' '}
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://play.google.com/store/apps/details?id=com.codedirectory"
                >
                    <span className="underline decoration-1 ">Play Market</span>
                </a>
                .
            </p>
            <h2 className="mb-5">Skills Section</h2>
            <div className="flex flex-wrap items-center">
                {mySkills.map((i) => (
                    <div className="hover:scale-90 cursor-pointer bg-custom-yellow py-1 px-5 text-black text-lg md:text-xs font-black border-[3px] border-solid border-black rounded-lg transition-all duration-300 m-[2px]">
                        {i}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default About
